import { BaseModel } from "sjs-base-model";

export default class InfoDocumentsModel extends BaseModel {
    public readonly fileId: string = "";
    public readonly fileName: string = "";
    public readonly printDossierCode: number = 0;
    public readonly printCode: number = 0;
    public readonly documentName: string = "";
    public readonly documentCode: string = "";
    public readonly documentDescription: string = "";
    public readonly documentType: number = 0;

    constructor(data: Partial<InfoDocumentsModel>) {
        super();

        this.update(data);
    }
}
